//#region Libraries
import { Row } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    width: 100%;
    gap: 10px;
`;
export const ContainerTooltip = styled(Row)`
    margin-left: 3px;
    @media (min-width: 948px) {
        & > *:first-child {
            position: fixed;
        }
    }
`;